import { z } from 'zod';

export enum CUSTOMER_TYPE_VALUES {
  PAY_MONTHLY = 'M',
  PAY_AS_GO = 'G',
  BUSINESS = 'B',
  NOT_CUSTOMER = 'N',
}

export enum PRODUCT_TYPE_VALUES {
  PHONE_PRODUCTS = 'pho',
  TABLET_PRODUCTS = 'tab',
  ACCESSORY_PRODUCTS = 'acc',
  FIVEG_PRODUCTS = '5gn',
  PERK_PRODUCTS = 'per',
  NEW_PRODUCTS = 'npl',
}

export enum BRAND_TYPE_VALUES {
  APPLE_BRAND = 'app',
  SAMSUNG_BRAND = 'sam',
  GOOGLE_BRAND = 'goo',
  SONY_BRAND = 'son',
  OTHER_BRAND = 'omf',
}

export enum FORM_ERROR_MESSAGES {
  FIRST_NAME_REQUIRED = 'First name Required.',
  FIRST_NAME_EXCEEDED = 'First name has exceeded character limit.',
  LAST_NAME_REQUIRED = 'Last name Required.',
  LAST_NAME_EXCEEDED = 'Last name has exceeded character limit.',
  EMAIL_REQUIRED = 'Email Required.',
  EMAIL_EXCEEDED = 'Email has exceeded character limit.',
  EMAIL_INVALID = 'Invalid Email.',
  CONTACT_NUMBER_INVALID = 'Invalid Contact Number.',
  CONTACT_NUMBER_REQUIRED = 'Mobile number Required.',
  CUSTOMER_TYPE_REQUIRED = 'Your Tariff is Required.',
}

const PHONE_REGEX = /^07\d{9}$/;

export const getReleaseUpdatesSchema = z.object({
  firstName: z
    .string()
    .min(1, FORM_ERROR_MESSAGES.FIRST_NAME_REQUIRED)
    .max(50, FORM_ERROR_MESSAGES.FIRST_NAME_EXCEEDED),
  lastName: z
    .string()
    .min(1, FORM_ERROR_MESSAGES.LAST_NAME_REQUIRED)
    .max(50, FORM_ERROR_MESSAGES.LAST_NAME_EXCEEDED),
  emailAddr: z
    .string()
    .min(1, { message: FORM_ERROR_MESSAGES.EMAIL_REQUIRED })
    .max(120, FORM_ERROR_MESSAGES.EMAIL_EXCEEDED)
    .email(FORM_ERROR_MESSAGES.EMAIL_INVALID),
  contactNo: z
    .string()
    .min(1, FORM_ERROR_MESSAGES.CONTACT_NUMBER_REQUIRED)
    .regex(PHONE_REGEX, FORM_ERROR_MESSAGES.CONTACT_NUMBER_INVALID),
  customerType: z
    .nativeEnum(CUSTOMER_TYPE_VALUES)
    .nullable()
    .refine(Boolean, FORM_ERROR_MESSAGES.CUSTOMER_TYPE_REQUIRED),
  brands: z.preprocess(
    (val) => {
      if (val === false) return [];
      return val;
    },
    z.array(z.nativeEnum(BRAND_TYPE_VALUES))
  ),
  productsAndServices: z.preprocess(
    (val) => {
      if (val === false) return [];
      return val;
    },
    z.array(z.nativeEnum(PRODUCT_TYPE_VALUES))
  ),
});

export type GetReleaseUpdatesForm = z.infer<typeof getReleaseUpdatesSchema>;
